import useMarkdown from "./useMarkdown";
import adminApi from "@/api/admin";

export const langOk = (modelTranslations, langCode, requiredProps) => {
    let ok = true;

    requiredProps.forEach(prop => {
        if (!modelTranslations[langCode][prop])
            ok = false;
    });

    return ok;
}

export const getValidTranslations = (modelTranslations, requiredProps) => {
    let validTranslations = {};
    Object.keys(modelTranslations).forEach(langCode => {
        if (langOk(modelTranslations, langCode, requiredProps))
            validTranslations[langCode] = modelTranslations[langCode];
    });

    return validTranslations;
}

export const convertTranslationsHtmlToMarkdown = (translations, propsToConvert) => {
    const { htmlToMarkdown } = useMarkdown();

    Object.keys(translations).forEach(lang => {
        Object.keys(translations[lang]).forEach(prop => {
            if (propsToConvert.indexOf(prop) > -1) {
                const html = translations[lang][prop].replace(" </strong>", "</strong> ").replace(" </em>", "</em> ");
                const markDown = htmlToMarkdown(html);

                translations[lang][prop] = markDown
            }
        });
    });

    return translations;
}

export const convertTranslationMarkdownToHtml = (translations, propsToConvert) => {
    const { markdownToHtml } = useMarkdown();

    Object.keys(translations).forEach(lang => {
        Object.keys(translations[lang]).forEach(prop => {
            if (propsToConvert.indexOf(prop) > -1) {
                const markDown = translations[lang][prop];
                const html = markdownToHtml(markDown);
                translations[lang][prop] = html;
            }
        });
    });

    return translations;
}

export const translateObjectTranslations = async (translationsObject, sourceLangCode, targetLanguageCodes, fieldsToTranslate) => {
    let errors = [];
    for (let l = 0; l < targetLanguageCodes.length; l++) {
        let lang = targetLanguageCodes[l];
        if (lang !== sourceLangCode) {
            for (let p = 0; p < fieldsToTranslate.length; p++) {
                const field = fieldsToTranslate[p];
                if (translationsObject[sourceLangCode][field]) {
                    const res = await adminApi.translateText(sourceLangCode, lang, translationsObject[sourceLangCode][field]);
                    if (res.ok) {
                        translationsObject[lang][field] = res.data;
                    }
                    else {
                        errors.push(`${lang} ${field}: ${JSON.stringify(res.error)}`);
                    }
                }
                await new Promise(r => setTimeout(r, 100));
            }
        }
    }
    return errors;
}

